const callDate = {
    name: 'Call Date',
    value: 'created_at',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byDate',
    },
    disabled: true,
    minWidth: 150,
    padding: 'px-2',
}

const campaign = {
    name: 'Campaign',
    value: 'campaign_name',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byCampaign',
    },
    minWidth: 90,
    padding: 'px-2',
}

const trafficSource = {
    name: 'Traffic Source',
    value: 'traffic_source',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byTrafficSource',
    },
    minWidth: 120,
    padding: 'px-2',
}

const vendor = {
    name: 'Vendor',
    value: 'vendor_name',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byVendor',
    },
    minWidth: 80,
    padding: 'px-2',
}

const callerId = {
    name: 'Caller ID',
    value: 'caller_number',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byCaller',
    },
    minWidth: 100,
    padding: 'px-2',
}

const dialed = {
    name: 'Dialed',
    value: 'dialed',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byDialed',
    },
    minWidth: 100,
    padding: 'px-2',
}

const dupe = {
    name: 'Dupe',
    value: 'dupe',
    align: 'center',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byDupe',
    },
    minWidth: 65,
    padding: 'px-2',
}

const duplicateRevenue = {
    name: 'Duplicate Revenue',
    value: 'duplicate_revenue',
    align: 'center',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byDuplicateRevenue',
    },
    activeDefault: false,
    minWidth: 150,
    padding: 'px-2',
}

const destination = {
    name: 'Destination',
    value: 'destination_name',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byDestinationName',
    },
    minWidth: 105,
    padding: 'px-2',
}

const destinationNumber = {
    name: 'Destination #',
    value: 'destination_number',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byDestinationNumber',
    },
    activeDefault: false,
    minWidth: 115,
    padding: 'px-2',
}

const buyer = {
    name: 'Buyer',
    value: 'buyer_name',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byBuyer',
    },
    minWidth: 70,
    padding: 'px-2',
}

const revenue = {
    name: 'Revenue',
    value: 'revenue',
    align: 'center',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byRevenue',
    },
    minWidth: 85,
    padding: 'px-2',
}

const payout = {
    name: 'Payout',
    value: 'payout',
    align: 'center',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byPayout',
    },
    minWidth: 85,
    padding: 'px-2',
}

const ttc = {
    name: 'TTC',
    value: 'ttc',
    align: 'center',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byTtc',
    },
    minWidth: 75,
    padding: 'px-2',
}

const duration = {
    name: 'Duration',
    value: 'duration',
    align: 'center',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byDuration',
    },
    minWidth: 95,
    padding: 'px-2',
}

const hangup = {
    name: 'Hang Up',
    value: 'hangup_source',
    align: 'center',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byHangup',
    },
    minWidth: 85,
    padding: 'px-2',
}

const status = {
    name: 'Status',
    value: 'status',
    align: 'center',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byStatus',
    },
    minWidth: 80,
    padding: 'px-2',
}

const failReason = {
    name: 'Fail Reason',
    value: 'failReason',
    align: 'center',
    sortSettings: {
        onlySort: true,
        key: '',
        sortBy: 'byFailReason',
    },
    minWidth: 130,
    padding: 'px-2',
}

const record = {
    name: 'Rec.',
    value: 'record',
    align: 'center',
    padding: 'px-2',
    minWidth: 50,
}

const transcription = {
    name: 'Transcription',
    value: 'transcription',
    align: 'center',
    padding: 'px-2',
    minWidth: 50,
    ai: true,
}

const qualification = {
    name: 'Qualification',
    value: 'qualification',
    align: 'center',
    padding: 'px-2',
    minWidth: 50,
}

const tag = {
    name: 'Tag',
    value: 'tags',
    padding: 'px-2',
    minWidth: 100,
}

const actions = {
    name: 'Actions',
    value: 'actions',
    align: 'center',
    disabled: true,
    padding: 'px-2',
    minWidth: 100,
}

const MANAGER_HEADERS = [
    callDate,
    campaign,
    vendor,
    callerId,
    dialed,
    dupe,
    duplicateRevenue,
    destination,
    destinationNumber,
    buyer,
    trafficSource,
    revenue,
    payout,
    ttc,
    duration,
    hangup,
    tag,
    status,
    failReason,
    record,
    transcription,
    qualification,
    actions,
]

const VENDOR_HEADERS = [
    callDate,
    campaign,
    vendor,
    callerId,
    dialed,
    dupe,
    trafficSource,
    revenue,
    duration,
    hangup,
    tag,
    status,
    failReason,
    record,
    actions,
]

const BUYER_HEADERS = [
    callDate,
    callerId,
    destination,
    destinationNumber,
    payout,
    duration,
    hangup,
    tag,
    status,
    record,
    actions,
]

export {
    MANAGER_HEADERS, VENDOR_HEADERS, BUYER_HEADERS, transcription, qualification,
}
